import enums from "../enums";

//user info
let user_data = localStorage.getItem("user_data");
if (user_data) {
	user_data = JSON.parse(user_data);
} else {
	user_data = {};
}

/**
 * Authentication state object
 * @param {Object} state Store item's state
 * @param {Object} action
 */
const auth = (
	state = {
		user: user_data,
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case enums.LOGIN_LOADING: {
			return { ...state, loading: action.payload };
		}
		case enums.LOGIN_SUCCESS: {
			return { ...state, user: action.payload };
		}
		case enums.LOGOUT_SUCCESS: {
			return { ...state, user: {}, updateProfileRequired: false };
		}
		case enums.PROFILE_UPDATE_REQUIRED: {
			return { ...state, updateProfileRequired: action.payload };
		}
		default:
			return { ...state };
	}
};

export default auth;
